import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import Styled from 'styled-components';
import Slider from "react-slick";
import { BASE_URL } from './Config/Config';
function Testimonialarea() {
   const [testimonialsdata , settestimonialsdata] = useState([]);
  const location = useLocation();
   const API = `${BASE_URL}/testimonial/`;
    const getTestimonial = async(url)=>{
      try{
      const response = await fetch(url ,{
        method: "GET",
        headers: {
          'content-type': "application/json"
        },
         credentials: "include",
      });


     if(!response){
        console.log("faild fatching data ");
     }
     else{
        const testimonialsdata = await response.json();
        settestimonialsdata(testimonialsdata.data)
      }
      
  }
catch (error) {
      console.log(error);
}
      
}

   useEffect(()=>{
       getTestimonial(API);
    },[]);




  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });

    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  },[location.pathname]); 


  const sliderSettings = {
    dots: true,
     customPaging: i => (
    <button
      style={{
        width: "12px",
        height: "12px",
        backgroundColor: "gray",
        borderRadius: "50%",
        border: "none",
        // opacity: "0.5"
      }}
    ></button>),
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    ltr: true, // Enable right-to-left sliding
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };
console.log(testimonialsdata);
  return (
    <>
    <Wrapper>
 <section className="testi-area-4 overflow-hidden space" data-bg-src="/assets/img/bg/testi_bg_3.png">
  <div className="shape-mockup testi2-bg-shape2 spin d-xl-block d-none" data-left="2%" data-top="20%">
    <img src="/assets/img/testimonial/testi-bg-shape_3_1.png" alt="img" />
  </div>
  <div className="shape-mockup testi2-bg-shape3 spin d-lg-block d-none" data-right="4%" data-bottom="10%">
    <img src="/assets/img/testimonial/testi-bg-shape_3_1.png" alt="img" />
  </div>
  <div className="container">
    
    <div className="title-area text-center">
      <span className="sub-title"><i className="fal fa-book me-2" /> Our Students Testimonials</span>
         <h2 className="sec-title text-white">Students Say’s About Us!</h2>
    </div>
  </div>
 
  
  <div className="container-fluid">
    <Slider {...sliderSettings}>
      {
     testimonialsdata.map((curdata , index)=>(

        <div key={curdata.id || index } className="row slider-shadow th-carousel testi-slider-4 dot-style2" data-slide-show={4} data-ml-slide-show={3} data-lg-slide-show={2} data-md-slide-show={1} data-dots="true">
             <div className="col-lg-6">
        <div className="testi-box style3">
          <div className="course-rating">
                    <div
                   className="star-rating"
                   role="img"
                   aria-label={`Rated ${curdata.rating} out of 5`}
                   >
                  <span style={{ width: `${(curdata.rating / 5) * 100}%`, }}>
                  Rated <strong className="rating">{curdata.rating}</strong> out of 5
                  </span>
                  </div>
                ({curdata.rating})
                </div>

          <div className="testi-box-bg-shape">
            <svg width={78} height={111} viewBox="0 0 78 111" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0L78 30V71C78 93.0914 60.0914 111 38 111H10C4.47715 111 0 106.523 0 101V0Z" fill="#0D5EF4" />
            </svg>
          </div>

          <div className="testi-box_content">
            <p className="testi-box_text">{curdata.text}</p>
          </div>

          <div className="testi-box_bottom">        
            <div className="testi-box_img">
              <img src={curdata.avatar ? `${BASE_URL}${curdata.avatar}` : "/assets/img/testingimg.jpg_img.webp"}alt="Auratech testimonial user img" style={{height:"120px" , width:"121px" , objectFit:"contain"}} />
            </div>

            <div className="testi-box-author-details">
              <h3 className="testi-box_name">{curdata.name}</h3>
              <span className="testi-box_desig">{curdata.designation}</span>
            </div>
            <div className="testi-box_quote">
              <img src="/assets/img/icon/testi-quote2.svg" alt="quote" />
            </div>
          </div>

        </div>
      </div>
     </div>
   ))}
      </Slider>
   </div>
   </section>
   </Wrapper>
  </>
  )
}

 const Wrapper = Styled.section`
 .row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; 
  width: 100%;
  }
  
  .col-lg-6 {
    flex: 0 0 50%; 
    width: 100%;
    }
    
    .testi-box {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      padding: 20px;
      position: relative;
      width: 100%;
      }
      
      .testi-box_review {
        margin-bottom: 10px;
        width: 100%;
}

.testi-box_content {
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
  width: 100%;
  }
  
  
  .testi-box_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}




/* Force equal height and clean layout */
.testi-slider-4 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.testi-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  // background-color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}

/* Make sure all cards match height by using min-height */
.testi-box_content {
  flex-grow: 1;
  min-height: 120px; /* Adjust based on expected max content */
}

/* Optional: ellipsis if text is too long */
.testi-box_text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* Show only 5 lines */
  -webkit-box-orient: vertical;
}

 `;


export default Testimonialarea